
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { fetchManufacturingCompanies, fetchTurbineModel, postNewBladeModel } from "@/helpers/api";
import { Companies, TurbineModel } from "@/interfaces/systemsdb";

export default defineComponent({
  name: "NewBladeModelModal",
  props: {
    selectedItem: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "save"],
  setup(props, { emit }) {
    const state = reactive({
      loading: false as boolean,

      saving: false as boolean,

      manufacturing_companies: [] as Companies[],
      design_companies: [] as Companies[],
      turbineModels: [] as TurbineModel[],

      form: {
        model_name: null as string | null,
        length: null as string | null,
        release_year: null as number | null,
        matrix: null as string | null,
        pitch_control_type: null as string | null,
        root_retention_method: null as string | null,
        designer_id: null as number | null,
        model_id: null as number | null,
        manufacturer: null as number | null,
      },
      errorMsg: "" as string,
    });

    const loadTurbineModelsForDesigner = async () => {
      state.form.model_id = null;
      state.turbineModels = [];

      if (!state.form.designer_id) {
        return;
      }

      try {
        state.turbineModels = await fetchTurbineModel(String(state.form.designer_id));
      } catch (error) {
        state.errorMsg = error instanceof Error ? error.message : "Failed to load turbine models";
      }
    };

    const loadOptions = async () => {
      state.loading = true;
      try {
        const [manufacturingCompaniesData, designCompaniesData] = await Promise.all([
          fetchManufacturingCompanies(),
          fetchManufacturingCompanies(),
        ]);

        state.manufacturing_companies = manufacturingCompaniesData;
        state.design_companies = designCompaniesData;
      } catch (error) {
        state.errorMsg = error instanceof Error ? error.message : "Failed to load options";
      } finally {
        state.loading = false;
      }
    };

    const save = async () => {
      state.errorMsg = "";
      state.saving = true;

      try {
        //await postNewBladeModel({...state.form});

        emit("save", {
          form: {
            ...state.form,
          },
        });

        emit("close");
      } catch (error) {
        state.errorMsg = error instanceof Error ? error.message : "Failed to save aggregator";
      } finally {
        state.saving = false;
      }
    };

    const close = () => {
      emit("close");
    };

    onMounted(loadOptions);

    return {
      ...toRefs(state),
      save,
      close,
      loadTurbineModelsForDesigner,
      postNewBladeModel,
    };
  },
});
